import {
  register,
  socialRegister,
  getProviderInfo,
  getUserProviderList,
  emailProviderBinding
} from '../../api/register'
import {
  REGISTER,
  SOCIAL_REGISTER,
  GET_PROVIDER_INFO,
  SET_EMAIL_ERROR,
  SET_PROVIDER,
  SET_DISPLAY_NAME,
  SET_PROVIDERS,
  RESET_EMAIL_ERROR,
  GET_USER_PROVIDERS,
  SET_PROFILE_PIC_URL,
  EMAIL_PROVIDER_BINDING,
  SET_USER_EMAIL,
  CLEAR_REGISTER_STATE
} from './constant'
import { AUTH_MODULE, SET_PASSWORD_ERROR } from '../auth/constant'
import { ActionTree } from 'vuex'
import { RegisterState } from './types'
import { Response, RedirectResponse, EmailBinding, UserProvidersResponse } from '../../api/type'
import { APP_MODULE, SET_IS_LOADING } from '../app/constant'

export const actions: ActionTree<RegisterState, any> = {
  async [REGISTER]({ commit }, payload) {
    try {
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, true, { root: true })

      let resp = await register(payload)
      const data = resp as Response
      const redirectData = data.data as RedirectResponse
      location.replace(redirectData.redirect_to)
      return
    } catch (e) {
      const errorResp = e as Response
      commit(SET_EMAIL_ERROR, errorResp?.error_message)
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, false, { root: true })
      return
    }
  },
  async [EMAIL_PROVIDER_BINDING]({ commit }, payload) {
    try {
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, true, { root: true })
      let resp = await emailProviderBinding(payload)
      const data = resp as Response
      const redirectData = data.data as RedirectResponse
      location.replace(redirectData.redirect_to)
      return
    } catch (e) {
      const errorResp = e as Response
      commit(`${AUTH_MODULE}/${SET_PASSWORD_ERROR}`, errorResp?.error_message, { root: true })
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, false, { root: true })
      return
    }
  },
  async [SOCIAL_REGISTER]({ commit }, payload) {
    try {
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, true, { root: true })
      let resp = await socialRegister(payload)
      const data = resp as Response
      const redirectData = data.data as RedirectResponse
      location.replace(redirectData.redirect_to)
      return
    } catch (e) {
      const errorResp = e as Response
      commit(SET_EMAIL_ERROR, errorResp?.error_message)
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, false, { root: true })
      return
    }
  },
  async [GET_PROVIDER_INFO]({ commit }, payload) {
    try {
      let resp = await getProviderInfo(payload)
      const data = resp as Response
      const registerData = data.data as EmailBinding
      commit(SET_PROVIDER, registerData.provider)
      commit(SET_DISPLAY_NAME, registerData.display_name)
      return
    } catch (e) {
      return
    }
  },
  async [GET_USER_PROVIDERS]({ commit }, payload) {
    try {
      let resp = await getUserProviderList(payload)
      const data = resp as Response
      const userProvidersData = data.data as UserProvidersResponse
      commit(SET_DISPLAY_NAME, userProvidersData.display_name)
      commit(SET_PROVIDERS, userProvidersData.providers)
      commit(SET_PROFILE_PIC_URL, userProvidersData.profile_url)
      commit(SET_USER_EMAIL, userProvidersData.email)
      return
    } catch (e) {
      return
    }
  },
  [RESET_EMAIL_ERROR]({ commit }) {
    commit(SET_EMAIL_ERROR, false)
  },
  [CLEAR_REGISTER_STATE]({ commit }) {
    commit(SET_DISPLAY_NAME, '')
    commit(SET_PROVIDERS, [])
    commit(SET_PROFILE_PIC_URL, '')
    commit(SET_USER_EMAIL, '')
    commit(SET_EMAIL_ERROR, '')
  }
}
